module.exports = __webpack_public_path__ + "static/media/abbe_and_alva.8e96a993.png";